export default __webpack_public_path__ + "static/media/Col.ea74352a.svg";